// extracted by mini-css-extract-plugin
export var legOdds = "MultiLegRow-module--legOdds--c4391";
export var newOdds = "MultiLegRow-module--newOdds--94846";
export var oddsChange = "MultiLegRow-module--oddsChange--81466";
export var previousOdds = "MultiLegRow-module--previousOdds--39d50";